import React from "react";
import { getLocalString, localNames } from "utils/localisation.service";
import { useSelector } from 'react-redux';

function renderSwitch(param, locales) {
    switch (param) {
        //Υποβολή Αίτησης
        case 'task.name.submit_application':
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_SUBMITAPPLICATION)}</span></div>;
        //CoE
        case 'task.name.application_evaluation':
            return <div className="application-badge coe-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATION)}</span></div>;
        //Υποβολή στο ΤΑΑ
        case 'task.name.application_evaluated':
            return <div className="application-badge submit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATED)}</span></div>;
        case 'task.name.loans_application':
            return <div className="application-badge completion-badge"><span>{getLocalString(locales, localNames.TASK_NAME_LOANS_APPLICATION)}</span></div>;
            //Απόρριψη Αίτησης
        case 'task.name.application_rejected':
            return <div className="application-badge reject-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTED)}</span></div>;
        //Ακύρωση Αίτησης (ακύρωση από Ωφελούμενο)
        case 'task.name.cancel':
            return <div className="application-badge cancel-badge"><span>{getLocalString(locales, localNames.TASK_NAME_CANCELAPPLICATION)}</span></div>;
        case 'task.name.complete':
            return <div className="application-badge completion-badge"><span>{getLocalString(locales, localNames.TASK_NAME_COMPLETE)}</span></div>;
        default:
            return null;
    }
}

const StatusTag = (props) => {
    const locales = useSelector(state => state.forms?.localeStrings);
    return renderSwitch(props.status, locales);
}

export default StatusTag;